import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import { getAdjusterOtherDamagedImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getAdjusterOtherDamagedImages/getAdjusterOtherDamagedImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

export default () => {
  return (
    <MainLayout title=" تصاویر / زیان‌دیده" header="titleHeader">
      <ShowOtherDamagedImages />
    </MainLayout>
  );
};
const ShowOtherDamagedImages = () => {
  const { id, damagedId } = useParams();

  const { data: imagesData, isPending } = useQuery(
    getAdjusterOtherDamagedImagesQueryOptions({
      damaged_id: damagedId!,
      id: id!,
    }),
  );
  if (isPending) {
    return <LoadingPage />;
  }
  return (
    <Box pt="1.5rem">
      <TitleDescription>تصاویر زیان‌دیده</TitleDescription>

      {!imagesData?.length ? (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      ) : (
        <>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.map((images) => {
              return (
                <ImageCard
                  key={images.id}
                  imageData={{
                    name: images.title?.fa_const,
                    src: images.image,
                  }}
                />
              );
            })}
          </Flex>
        </>
      )}
    </Box>
  );
};
